import React from 'react';
import '../styles/Facilities.css';

const Facilities = () => {
  return (
    <section className="facilities">
      {/* Hero Section */}
      <div className="facilities-hero">
        <h1>Our Facilities</h1>
        <p>
          Explore our state-of-the-art manufacturing facilities that ensure top-notch quality and precision in every product.
        </p>
      </div>
      <h2 className='heading'>Industry-Leading CNC Machining Capabilities</h2>
      {/* Two Container Layout */}
      <div className='facility-container'>
      <div className="facility-layout1">
        
        {/* Left Container: Image */}
        <div className="facility-image-container">
          <img
            src="https://sybridge.com/wp-content/uploads/2023/06/Technologies-CNC-3axis-1.jpg"
            alt="CNC Machining"
            className="facility-image"
          />
        </div>

        {/* Right Container: Description */}
        <div className="facility-description">
          <h2>Milling machine</h2>
          <p>
          3-axis CNC milling involves cutting along three linear axes: left-to-right, back-and-forth, up-and-down. Easy to program and operate, 3-axis mills are effective for simple geometric designs and can be used for a wide variety of parts.
          </p>
          <p>
            Our facilities leverage cutting-edge technology to produce components with exceptional accuracy, ensuring durability and performance in every project.
          </p>
        </div>
      </div>
      
      <div className="facility-layout2">
        {/* Left Container: Image */}
        <div className="facility-image-container">
          <img
            src="https://sybridge.com/wp-content/uploads/2023/06/Technologies_CNC-Machining_-CNC-Turning-madison-hoare-1200x900.jpeg"
            alt="CNC Machining"
            className="facility-image"
          />
        </div>

        {/* Right Container: Description */}
        <div className="facility-description">
          <h2>CNC Turning</h2>
          <p>CNC turning involves the application of a cutting tool to a rotating blank workpiece in order to shape a desired part.
             During production, the workpiece spins on vertical or horizontal axes while the automated lathe moves around it. Precise, 
             repeatable and scalable, CNC turning is ideal for creating parts with simple geometries in rounded or cylindrical shapes.</p>
          
        </div>

        
      </div>

      <div className="facility-layout3">
        
        {/* Left Container: Image */}
        <div className="facility-image-container">
          <img
            src="https://img.freepik.com/free-photo/worker-operating-industrial-machine-metal-workshop_342744-268.jpg?t=st=1731147652~exp=1731151252~hmac=68e42ed7f556d9a63eaec86f95dbf843bb07649f90fb31aef54025c1252b34c8&w=1060"
            alt="CNC Machining"
            className="facility-image"
          />
        </div>

        {/* Right Container: Description */}
        <div className="facility-description">
          <h2>VMC</h2>
          <p>Vertical Machining Centers (VMC) represent a cornerstone in modern manufacturing, revolutionizing the way industries produce precision parts and components. These machines, also known as Vertical Milling Machines, have become integral to various sectors such as aerospace, automotive, medical devices, and more. Understanding the fundamentals of VMC machines is essential to appreciate their significance in today’s manufacturing landscape.</p>
        </div>
      </div>

      <div className="facility-layout4">
        {/* Left Container: Image */}
        <div className="facility-image-container">
          <img
            src="https://th.bing.com/th/id/OIP.SyRkwe4eeXcO7albU0S-PAHaFu?rs=1&pid=ImgDetMain"
            alt="CNC Machining"
            className="facility-image"
          />
        </div>

        {/* Right Container: Description */}
        <div className="facility-description">
          <h2>Sliding Head CNC </h2>
          <p>Sliding head machining, also known as Swiss tooling or Swiss turning, is a highly advanced and versatile machining process. As a leading subcontract machining company, Metaltech Precision has invested heavily in sliding head machining centres, enhancing the ability of this precision machining company to supply high precision, high quality technical components to customers quickly and efficiently. </p>
          
        </div>
        </div>
        
      </div>
          <h2 className='plants'>Plant & Building</h2>
      
          <div className="facility-double-image-container">
        {/* Image 1 with Description */}
        <div className="facility-image-box">
          <img
            src={require('../assets/sujayindustry.JPG')}
            alt="Machinery"
            className="double-image"
          />
          <ul className="image-description-list">
            <h1>UNIT 1</h1>
             <li>136B, KIADB Industrial Area</li>
            <li>Jigani Bommasandra Link Road</li>
            <li>Bengaluru 560105 </li>

        </ul>
        </div>

        {/* Image 2 with Description */}
        <div className="facility-image-box">
          <img
            src={require('../assets/sujayindustry.JPG')}
            alt="CNC Machine"
            className="double-image"
          />
          <ul className="image-description-list">
            <h1>UNIT 2</h1>
             <li>Plot 8, Avverahalli Industrial Area,</li>
            <li>Dabaspet 4th Phase,</li>
            <li>Bengaluru 562111 </li>

        </ul>
        </div>
      </div>

    </section>
  );
};

export default Facilities;
